import React, { Fragment, useState } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FMenuCard from "../../components/FMenuCard/FMenuCard";
import FContainer from "../../components/FContainer/FContainer";
import {
  ReaderOutline,
  LockClosedOutline,
  CashOutline,
  ChevronForward,
} from "react-ionicons";

const LegalNotices = ({ param }) => {
  const route = useNavigate();

  const profiles = [
    {
      title: "Términos",
      description: "Términos y condiciones",
      ico: <ReaderOutline height="24px" width="24px" />,
      iconBackground: "#fd6e0d",
      onclick: () => {
        route("/TermsAndConditions");
      },
    },
    {
      title: "Privacidad",
      description: "Avisos de privacidad",
      ico: <LockClosedOutline height="24px" width="24px" />,
      iconBackground: "#fd6e0d",

      onclick: () => {
        route("/TermsAndConditions");
      },
    },
  ];
  return (
    <>
      <FContainer>
        {profiles.map((profile) => (
          <div
            className="border-0 w-full grid grid-cols-12 shadow-Box rounded-2xl px-2 py-3 my-2 cursor-pointer"
            onClick={() => {
              profile.onclick();
            }}
          >
            <div
              className="border-0 col-span-2 grid place-items-center"
              onClick={() => {}}
            >
              <div className="bg-[#FD6E0D] p-[7px] rounded-full">
                {profile.ico}
              </div>
            </div>
            <div className="border-0 col-span-8 grid grid-cols-1 items-center font-regular text-[13px] pl-2">
              <div className="border-0 col-span-1 grid items-center font-bold text-[4vw] xxxs:text-[16px]">
                {profile.title}
              </div>
              <div className="border-0 col-span-1 grid items-start font-regular text-[4vw] xxxs:text-[13px]">
                {profile.description}
              </div>
            </div>
            <div className="border-0 col-span-2 gap-1 grid grid-cols-1 place-items-center">
              <div className="border-0 col-span-1">
                <ChevronForward height="25px" width="25px" />
              </div>
            </div>
          </div>
        ))}
      </FContainer>
    </>
  );
};

export default LegalNotices;
